"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSlicePath = exports.getSliceDetails = exports.getSliceUrl = exports.getSliceVersions = exports.getSliceName = void 0;
var tslib_1 = require("tslib");
function getSliceName(packageName, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.root, root = _c === void 0 ? false : _c;
    var name = "_".concat(packageName
        .replace(/@/g, '')
        .replace(/[^a-z0-9+]+/gi, '_'));
    return root ? "__root_$l1c3_".concat(name) : name;
}
exports.getSliceName = getSliceName;
var removeTrailingSlash = function (str) { return str.replace(/\/+$/g, ''); };
/**
 * It fetches and returns data from the versions.json file in the slice's origin if it exists
 * @param  - `origin` - The origin of the slice.
 * @returns { latest: string; allVersions: string[] } | undefined
 */
function getSliceVersions(_a) {
    var origin = _a.origin, packageName = _a.packageName;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var url, error_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat(removeTrailingSlash(origin), "/slices/").concat(getSliceName(packageName), "/versions.json");
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url)];
                case 2: return [4 /*yield*/, (_b.sent()).json()];
                case 3: return [2 /*return*/, (_b.sent())];
                case 4:
                    error_1 = _b.sent();
                    // This slice may not have versions.json yet so return nothing
                    return [2 /*return*/, undefined];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.getSliceVersions = getSliceVersions;
function getSliceUrl(_a) {
    var _b, _c;
    var origin = _a.origin, packageName = _a.packageName, _d = _a.version, version = _d === void 0 ? 'latest' : _d;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var returnVersion;
        return tslib_1.__generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    returnVersion = version;
                    if (!(version === 'latest')) return [3 /*break*/, 2];
                    return [4 /*yield*/, getSliceVersions({ origin: origin, packageName: packageName })];
                case 1:
                    returnVersion =
                        (_c = (_b = (_e.sent())) === null || _b === void 0 ? void 0 : _b.latest) !== null && _c !== void 0 ? _c : 'latest';
                    _e.label = 2;
                case 2: return [2 /*return*/, "".concat(removeTrailingSlash(origin)).concat(getSlicePath({
                        packageName: packageName,
                        version: returnVersion,
                    }), "/remoteEntry.js")];
            }
        });
    });
}
exports.getSliceUrl = getSliceUrl;
function getSliceDetails(_a) {
    var packageName = _a.packageName, url = _a.url, disableCdnCache = _a.disableCdnCache;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var name, hash, sliceUrl, version;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    name = getSliceName(packageName);
                    hash = "?hash=".concat(Date.now());
                    if (!(typeof url === 'string')) return [3 /*break*/, 1];
                    sliceUrl = url;
                    return [3 /*break*/, 3];
                case 1:
                    if (!url.origin) return [3 /*break*/, 3];
                    version = url.version;
                    return [4 /*yield*/, getSliceUrl({ origin: url.origin, version: version, packageName: packageName })];
                case 2:
                    sliceUrl = _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/, {
                        sliceName: name,
                        sliceUrl: "".concat(sliceUrl).concat(disableCdnCache === true ? hash : ''),
                    }];
            }
        });
    });
}
exports.getSliceDetails = getSliceDetails;
function getSlicePath(_a) {
    var packageName = _a.packageName, version = _a.version, _b = _a.target, target = _b === void 0 ? 'web' : _b;
    return "/slices/".concat(getSliceName(packageName), "/").concat(version, "/").concat(target);
}
exports.getSlicePath = getSlicePath;
//# sourceMappingURL=sliceDetails.js.map